import React, { useState, useContext } from "react";
import { makeStyles, Paper, Tabs, Tab, Typography } from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import TabPanel from "../../components/TabPanel";

import BillingManager from "../../components/BillingManager";
import ClientUsageManager from "../../components/ClientUsageManager";

import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";

// Tela do dono da plataforma: o que é administração do negócio (faturamento,
// acompanhamento de uso dos clientes) e não configuração do sistema mora aqui.
// O Faturamento veio da tela de Configurações, onde estava fora de lugar.

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.palette.background.paper,
  },
  mainPaper: {
    ...theme.scrollbarStyles,
    overflowY: "scroll",
    flex: 1,
  },
  tab: {
    backgroundColor: theme.palette.options,
    borderRadius: 4,
  },
  paper: {
    ...theme.scrollbarStyles,
    overflowY: "scroll",
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  container: {
    width: "100%",
    maxHeight: "100%",
  },
  denied: {
    padding: theme.spacing(2),
  },
}));

const Gerenciamento = () => {
  const classes = useStyles();
  const [tab, setTab] = useState("billing");
  const { user } = useContext(AuthContext);

  // Mesma trava das abas de super em Configurações (Settings/index.js).
  const canManage = user && user.id === 1;

  return (
    <MainContainer className={classes.root}>
      <MainHeader>
        <Title>{i18n.t("mainDrawer.listItems.management")}</Title>
      </MainHeader>
      <Paper className={classes.mainPaper} elevation={1}>
        {!canManage ? (
          // Uma mensagem em vez de <Redirect>: a rota já é privada, redirecionar
          // daqui só produziria um pisca-pisca até o AuthContext carregar.
          <Typography className={classes.denied} color="textSecondary">
            {i18n.t("management.restricted")}
          </Typography>
        ) : (
          <>
            <Tabs
              value={tab}
              indicatorColor="primary"
              textColor="primary"
              scrollButtons="on"
              variant="scrollable"
              onChange={(e, newValue) => setTab(newValue)}
              className={classes.tab}
            >
              <Tab label={i18n.t("management.tabs.billing")} value={"billing"} />
              <Tab label={i18n.t("management.tabs.usage")} value={"usage"} />
            </Tabs>
            <Paper className={classes.paper} elevation={0}>
              <TabPanel className={classes.container} value={tab} name={"billing"}>
                <BillingManager />
              </TabPanel>
              <TabPanel className={classes.container} value={tab} name={"usage"}>
                <ClientUsageManager />
              </TabPanel>
            </Paper>
          </>
        )}
      </Paper>
    </MainContainer>
  );
};

export default Gerenciamento;
